import { useEffect } from 'react';
import { X } from 'lucide-react';

// iOS-style drop-down notification banner for in-app alerts — shared by the
// customer, driver and restaurant portals. Drops from the top of the screen,
// auto-dismisses after `duration` ms, tap = open.
export default function InAppNotificationBanner({ notification, onTap, onDismiss, duration = 4500 }) {
  useEffect(() => {
    if (!notification) return undefined;
    const t = setTimeout(() => onDismiss?.(), duration);
    return () => clearTimeout(t);
  }, [notification, duration]);

  if (!notification) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[60] px-3 pt-[max(env(safe-area-inset-top),8px)] pointer-events-none">
      <div
        role="button"
        tabIndex={0}
        onClick={onTap}
        onKeyDown={(e) => e.key === 'Enter' && onTap?.()}
        className="banner-drop pointer-events-auto mx-auto flex w-full max-w-lg items-start gap-3 rounded-2xl bg-white/95 px-4 py-3 shadow-xl backdrop-blur cursor-pointer select-none"
      >
        <img src="/ChefLogo.jpg" alt="" className="h-9 w-9 shrink-0 rounded-lg object-cover" />
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-semibold uppercase tracking-wide text-[#8E8E93]">CheF SKN</span>
            <span className="text-[11px] text-[#8E8E93]">now</span>
          </div>
          <p className="truncate text-[14px] font-semibold text-gray-900">
            {notification.title || 'Notification'}
          </p>
          <p className="line-clamp-2 text-[13px] text-[#6D6D72]">
            {notification.message || notification.body || ''}
          </p>
        </div>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={(e) => { e.stopPropagation(); onDismiss?.(); }}
          className="shrink-0 self-start p-1 text-[#8E8E93] active:text-gray-600"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
